<template>
  <el-config-provider :locale="zhCn">
    <router-view />
  </el-config-provider>
</template>

<script setup lang="ts">
import { onMounted, onUnmounted } from 'vue'
import { useAppStore } from '@/stores/modules/app'
import zhCn from 'element-plus/es/locale/lang/zh-cn'

const appStore = useAppStore()
const MOBILE_BREAKPOINT = 768

function handleResize() {
  const mobile = window.innerWidth <= MOBILE_BREAKPOINT
  appStore.setMobile(mobile)
  if (!mobile) {
    appStore.setDrawerVisible(false)
  }
}

onMounted(() => {
  handleResize()
  appStore.setThemeMode(appStore.themeMode)
  window.addEventListener('resize', handleResize)
})

onUnmounted(() => {
  window.removeEventListener('resize', handleResize)
})
</script>
